<template>
  <div class="DetailDrawer">
    <el-drawer
      size="1017px"
      :visible="visible"
      :show-close="false"
      :with-header="false"
      @open="handleOpen"
      @close="drawerClose"
      style="z-index: 4000"
      :append-to-body="isBody"
    >
      <div v-if="visible">
        <!-- 客户详情  潜客，成交 -->
        <CustomerDetail
          v-if="isCustomerDetail"
          ref="customDetail"
          :companyData="companyData"
          @emitAnewList="customerAnewList"
          @switchDetail="switchDetail"
          :isList="isAnalysis?isList:false"
          @closeDetail="closeDetail"
          @sendList="sendList"
          @turnPage="turnPage"
        />
        <!-- 联系人详情 全部客户-->
        <ContactDetail
          v-else
          ref="contactDetail"
          :companyData="contactData"
          @emitAnewList="contactAnewList"
          @switchDetail="switchDetail"
          :isList="isAnalysis?isList:false"
          @closeDetail="closeDetail"
          @turnPage="turnPage"
        />
      </div>
    </el-drawer>
  </div>
</template>

<script>
import CustomerDetail from '../../components/custom/customerDetail'
import ContactDetail from '../../components/custom/contactDetail'
export default {
  props: {
    // 客户详情id集合
    companyDataProp: {
      default: () => {},
    },
    // 联系人详情id集合
    contactDataProp: {
      default: () => {},
    },
    isBody: {
      default: false,
    },
    isAnalysis:{
      default:true
    }
  },
  watch: {
    companyDataProp: {
      handler(newVal) {
        this.companyData = newVal
      },
      immediate: true,
      deep: true,
    },
    contactDataProp: {
      handler(newVal) {
        this.contactData = newVal
      },
      immediate: true,
      deep: true,
    },
  },
  components: {
    CustomerDetail,
    ContactDetail,
  },
  data() {
    return {
      visible: false,
      zIndex: 1, // 0: 客户详情 1: 联系人详情
      isCustomerDetail: true,
      isList: true,
      companyData: {},
      contactData: {},
      hierarchy: 1,
      firstIsList: true,
    }
  },
  methods: {
    sendList(){
      setTimeout(()=>{
        this.$emit('getList')
      },2000)
    },
    // 抽屉打开时
    handleOpen() {
      this.firstIsList = this.isList
      if(window.localStorage.getItem('dialogFlags')){
        window.localStorage.removeItem('dialogFlags')
      }
    },
    // 关闭抽屉时
    drawerClose() {
      if(this.$route.query.customerId){
        let url=window.location.href.split('?')
        window.location.href=url[0]
      }
      this.closeDetail(!this.isCustomerDetail)
    },
    // 当客户详情关闭时
    customerAnewList() {},
    // 当联系人详情关闭时
    contactAnewList() {},
    /**
     * @description: 切换详情
     * @param {*} isCustomerDetail true: 客户详情  false: 联系人详情
     */
    switchDetail(isCustomerDetail, data) {
      this.isCustomerDetail = isCustomerDetail
      this[isCustomerDetail ? 'companyData' : 'contactData'] = data
      this.isList = false
      this.hierarchy++
      if (this.zIndex === 1) this.zIndex++
    },

    /**
     * @description: 关闭详情
     * @param {*} isCustomerDetail true: 客户详情  false: 联系人详情
     */
    closeDetail(isCustomerDetail) {
      console.log(isCustomerDetail)
      this.isCustomerDetail = isCustomerDetail
      if(--this.hierarchy == 1 && this.firstIsList) this.isList = true
      if (this.zIndex === 2) {
        // 如果当前是第二层，只关闭一层
        this.zIndex--
      } else {
        // 如果当前是第一层，直接关闭
        this.zIndex = 1
        this.hierarchy = 1
        this.visible = false
        this.$emit('emitAnewList')
      }
      if(!isCustomerDetail&&window.localStorage.getItem('dialogFlags')){
        window.localStorage.removeItem('dialogFlags')
      }
    },

    // 打开抽屉
    openDetailDrawer() {
      this.visible = true
    },

    /**
     * @description: 当客户详情或者联系人详情里面发生了翻页
     * @param {*} isCustomerDetail true: 客户详情  false: 联系人详情
     */
    turnPage(isCustomerDetail, data) {
      this.isCustomerDetail = isCustomerDetail
      this[isCustomerDetail ? 'companyData' : 'contactData'] = data
    }
  },
}
</script>

<style lang="scss" scoped>
.DetailDrawer {
}
</style>
